import React, { useMemo } from "react";
import {
  DetailsList,
  DetailsListLayoutMode,
  IconButton,
  SelectionMode,
  Stack,
  Text,
} from "@fluentui/react";
import FeatureSummary from "../../../Util/FeatureSummary";

const BenefitList = ({ benefits, onEdit, onDelete }) => {
  const items = useMemo(
    () => (benefits || []).map((benefit) => ({ ...benefit, key: benefit.benefitId })),
    [benefits]
  );

  const columns = useMemo(
    () => [
      {
        key: "providerName",
        name: "Provider",
        fieldName: "providerName",
        minWidth: 200,
        isResizable: true,
      },
      {
        key: "benefitCategory",
        name: "Category",
        fieldName: "benefitCategory",
        minWidth: 150,
        isResizable: true,
      },
      {
        key: "benefitType",
        name: "Type",
        fieldName: "benefitType",
        minWidth: 150,
        isResizable: true,
      },
      {
        key: "featuredOrder",
        name: "Featured Order",
        fieldName: "featuredOrder",
        minWidth: 120,
        isResizable: true,
        onRender: (item) => item.featuredOrder ?? "",
      },
      {
        key: "callToAction",
        name: "Call To Action",
        fieldName: "callToActionTitle",
        minWidth: 200,
        isResizable: true,
        onRender: (item) => item.callToActionTitle || "None",
      },
      {
        key: "actions",
        name: "Actions",
        minWidth: 120,
        isResizable: false,
        onRender: (item) => (
          <Stack horizontal tokens={{ childrenGap: 8 }}>
            <IconButton
              iconProps={{ iconName: "Edit" }}
              title="Edit"
              ariaLabel="Edit benefit"
              onClick={() => onEdit(item)}
            />
            <IconButton
              iconProps={{ iconName: "Delete" }}
              title="Delete"
              ariaLabel="Delete benefit"
              onClick={() => onDelete(item)}
            />
          </Stack>
        ),
      },
    ],
    [onEdit, onDelete]
  );

  if (!items.length) {
    return <Text>No benefits found for this cobrand.</Text>;
  }

  return (
    <>
      <DetailsList
        items={items}
        columns={columns}
        layoutMode={DetailsListLayoutMode.justified}
        selectionMode={SelectionMode.none}
        setKey="benefits"
      />
      <FeatureSummary
        label="About Cobrand Benefits"
        summary="This table displays all benefits for the selected cobrand, including provider, category, type, and call to action. You can edit or delete benefits. These appear as categories on '/benefits/all' if turned on for cobrand."
        imageUrlPath="benefits-hero"
      />
    </>
  );
};

export default BenefitList;
